import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Heading from './components/Header.vue'
import Content from './components/Content.vue'
import './assets/fonts.css'



import calendar from './plugins/calendar.js';
import sweetalert from './plugins/sweetalert.js';
import pagination from './plugins/pagination.js';
import fontawesome from "./plugins/fontawesome.js";
import vuetify from './plugins/vuetify.js';
import vform from './plugins/vform.js';

import { mavonEditor } from 'mavon-editor';
import 'mavon-editor/dist/markdown/github-markdown.min.css';
import 'mavon-editor/dist/css/index.css';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-vue';
// import '@ckeditor/ckeditor5-build-classic/build/style.css';


import messageHelper from './helpers/messageHelper.js';
import apiHelper from './helpers/apiHelper.js';
import loginHelper from './helpers/loginHelper.js';
import encryptionHelper from './helpers/encryptionHelper.js';
import dateHelper from './helpers/dateHelper.js';
import stringHelper from './helpers/stringHelper.js';
import numberHelper from './helpers/numberHelper.js';
import reportHelper from './helpers/reportHelper.js';



const app = createApp(App);
app.component('heading', Heading);
app.component('content', Content);
app.component('vue-pagination', pagination);
app.component('full-calendar', calendar);
app.component('mavon-editor', mavonEditor);
app.component('ckeditor', ClassicEditor);



import Select from 'vue-select';
app.component("vue-select", Select);

import ScrollDiv from 'vue-scroll-div';
app.use(ScrollDiv);

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
app.component('font-awesome-icon', FontAwesomeIcon);


app.mixin(messageHelper);
app.mixin(apiHelper);
app.mixin(loginHelper);
app.mixin(encryptionHelper);
app.mixin(dateHelper);
app.mixin(stringHelper);
app.mixin(numberHelper);
app.mixin(reportHelper);



app.use(store)
    .use(router)
    .use(sweetalert)
    .use(fontawesome)
    .use(vuetify)
    .use(vform)
    .use(ScrollDiv)
    .use(CKEditor)
    .mount('#app');
